/*
 * @Copyright: Copyright (c) Pray. All rights reserved.
 * @Author: Raguvind Tharanitharan
 * @Date: 2022-08-17 10:18:12
 * @Last Modified by: Raguvind Tharanitharan
 * @Last Modified time: 2022-09-18 10:21:01
*/

import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { Settings } from './module-dashboard';
import { User } from './common';

const reducer = combineReducers({
    settings: Settings,
    user: User
});
const RootStore = configureStore({
  reducer,

});
export default RootStore;